import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import useGlobal from '../../composables/useGlobal'
import { storage } from '@/utils/session'
import executeWithRefresh from '@/composables/useRefresher'
import { createSubscription } from '@/services/order.service'
import { subscriptionsList } from '@/services/sub.service'
import { STATE } from '@/utils/base64'

import {
  getCookie,
} from '@/utils/cookies'

import {
  HQ_VPN_ACCESS_TOKEN_STORAGE_NAME,
  HQ_REFERENCE_COOKIE_NAME,
} from '@/const'


export default /*#__PURE__*/_defineComponent({
  __name: 'Subscriptions',
  setup(__props, { expose }) {
  expose();

const isFinalStep = ref(false)
const extendSub = ref(false)
const isAuth = storage.getItem(HQ_VPN_ACCESS_TOKEN_STORAGE_NAME)
const reSelect = ref(false)
const { $t } = useGlobal()
const { indexPage } = window

const step = ref(1)
const subscription = ref('')
const subKey = ref('')
const list = ref('')
const idOrder = ref('')
const titles = ref([
  {
    title: $t('Вебери свою подписку и стань частью VPN #1 Амстердама')
  },
  {
    title: $t('Укажите адрес своей электронной почты:')
  },
  {
    title: $t('Выберите удобный для вас способ оплаты')
  },
])

const parseGetParams = () => {
  if (window.location.search) {
    const [search] = window.location.search.substring(1).split('&')
    const result = STATE.parse(search);
    return result
    
  }
}
const getSubscriptionList = async () => {
  const { data: { items } } = (await executeWithRefresh(subscriptionsList, null))
  list.value = items
}

const checkMethod = async () => {
  await getSubscriptionList()
  if (window.location.search) {
    const { subscription_id, key, order_id } = parseGetParams()
    if (order_id) idOrder.value = order_id
    if (subscription_id && !key) { getNextStep({ value: { step: 2 }}) }
    if ( subscription_id ) {
      const sub = list.value.find(e => e.id == subscription_id)
      subscription.value = sub
    }
    if (subscription_id && key || subscription_id && order_id) {
      if (key) {
        subKey.value = key
        isFinalStep.value = true
      }
      getNextStep({ value: { step: 3 }})
    }
  }
}

checkMethod()
getSubscriptionList()
// onMounted(() => {
// })

function reSelectSub() {
  step.value = 1
  reSelect.value = true
}

async function createOrder() {
  const prepearedData = {
    key: subKey.value,
    subscription: subscription.value.id,
    ref_id: getCookie(HQ_REFERENCE_COOKIE_NAME),
  }
  try {
    const res = (await executeWithRefresh(createSubscription, null, {}, prepearedData))
    idOrder.value = res.data.id
  } catch(e) {
    return Promise.reject(e)
  }
}

function getNextStep(data) {
  if(data.value.sub) subscription.value = data.value.sub
  if(data.value.orderId) {
    idOrder.value = data.value.orderId
  } 
  if(subKey.value) {
    createOrder()
  }
  step.value = data.value.step
}

// async function getPayment () {
//   const prepearedData = {
//     key: subKey?.value,
//     subscription: subscription.value.id
//   }
//   try {
//     const res = (await executeWithRefresh(createSubscription, null, {}, prepearedData))
   
//   } catch(e) {
//     return Promise.reject(e)
//   }
// }

  
const __returned__ = { isFinalStep, extendSub, isAuth, reSelect, $t, indexPage, step, subscription, subKey, list, idOrder, titles, parseGetParams, getSubscriptionList, checkMethod, reSelectSub, createOrder, getNextStep, ref, onMounted, useGlobal, storage, executeWithRefresh, createSubscription, subscriptionsList, STATE, getCookie, HQ_VPN_ACCESS_TOKEN_STORAGE_NAME, HQ_REFERENCE_COOKIE_NAME }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})